import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import { orderBy as sort } from "lodash";

import { SmallQuantityTicket } from "../interface/api/SmallQuantityTicket";
import { SmallQuantityTicketState } from "../interface/redux-types/SmallQuantityTicketState";
import { RootState } from "..";

const initialState: SmallQuantityTicketState = {
  tickets: [],
  ticket: null,
};

const slice = createSlice({
  name: "smallQuantityTicket",
  initialState,
  reducers: {
    setSmallQuantityTickets: (
      state,
      action: PayloadAction<{ tickets: SmallQuantityTicket[] }>
    ) => {
      state.tickets = action.payload.tickets;
    },
    setSmallQuantityTicket: (
      state,
      action: PayloadAction<{ ticket: SmallQuantityTicket | null }>
    ) => {
      state.ticket = action.payload.ticket;
    },
    updateSmallQuantityTicketInList: (
      state,
      action: PayloadAction<{ ticket: SmallQuantityTicket }>
    ) => {
      const { ticket } = action.payload;
      const index = state.tickets.findIndex((t) => t.id === ticket.id);
      if (index >= 0) {
        state.tickets[index] = ticket;
      }
    },
  },
});

export const {
  setSmallQuantityTickets,
  setSmallQuantityTicket,
  updateSmallQuantityTicketInList,
} = slice.actions;

export const getSmallQuantityTickets = createSelector(
  (state: RootState) => state.smallQuantityTicketStore?.tickets ?? [],
  (tickets) => sort(tickets, ["ticketNumber"], ["desc"])
);

export const getSmallQuantityTicket = createSelector(
  (state: RootState) => state.smallQuantityTicketStore?.ticket ?? null,
  (ticket) => ticket
);

export const reducer = slice.reducer;
